function parseColorChannel(value) {
  if (value.endsWith('%')) {
    return Math.round((Number.parseFloat(value) / 100) * 255);
  }

  return Number.parseFloat(value);
}

function normalizeChannel(value) {
  if (!Number.isFinite(value)) {
    return 0;
  }

  return Math.max(0, Math.min(1, value / 255));
}

function normalizeSrgbChannel(value) {
  if (!Number.isFinite(value)) {
    return 0;
  }

  return Math.max(0, Math.min(1, value > 1 ? value / 255 : value));
}

function parseCssColor(value) {
  const color = value.trim();

  if (color.startsWith('#')) {
    const raw = color.slice(1);
    const parts = raw.length === 3
      ? [...raw].map((part) => Number.parseInt(`${part}${part}`, 16))
      : [
          Number.parseInt(raw.slice(0, 2), 16),
          Number.parseInt(raw.slice(2, 4), 16),
          Number.parseInt(raw.slice(4, 6), 16),
        ];

    if (parts.every(Number.isFinite)) {
      return parts.map(normalizeChannel);
    }
  }

  const rgbMatch = color.match(/^rgba?\((.*)\)$/i);
  if (rgbMatch) {
    const channels = rgbMatch[1]
      .replace(/\s*\/.*$/, '')
      .split(/[,\s]+/)
      .filter(Boolean)
      .slice(0, 3)
      .map(parseColorChannel);

    if (channels.length === 3 && channels.every(Number.isFinite)) {
      return channels.map(normalizeChannel);
    }
  }

  const srgbMatch = color.match(/^color\(\s*srgb\s+(.*)\)$/i);
  if (srgbMatch) {
    const channels = srgbMatch[1]
      .replace(/\s*\/.*$/, '')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 3)
      .map((channel) => (
        channel.endsWith('%') ? Number.parseFloat(channel) / 100 : Number.parseFloat(channel)
      ));

    if (channels.length === 3 && channels.every(Number.isFinite)) {
      return channels.map(normalizeSrgbChannel);
    }
  }

  return null;
}

function readThemeColor(variableName) {
  const probe = document.createElement('span');
  probe.style.color = `var(${variableName})`;
  probe.style.position = 'absolute';
  probe.style.pointerEvents = 'none';
  probe.style.opacity = '0';
  document.body.appendChild(probe);

  const color = parseCssColor(window.getComputedStyle(probe).color);
  probe.remove();

  return color;
}

function mixColors(start, end, amount) {
  return start.map((channel, index) => (
    channel + (end[index] - channel) * amount
  ));
}

export function readShaderPalette() {
  const bg = readThemeColor('--bg-app') || [0.08, 0.08, 0.09];
  const panel = readThemeColor('--bg-panel-section') || bg;
  const text = readThemeColor('--text-secondary') || panel;
  const textPrimary = readThemeColor('--text-primary') || text;
  const brand = readThemeColor('--color-brand-accent') || readThemeColor('--accent-primary') || panel;
  const cyan = readThemeColor('--color-cyan-500') || brand;
  const violet = readThemeColor('--color-violet-500') || brand;
  const amber = readThemeColor('--color-amber-300') || readThemeColor('--color-amber-500') || brand;

  return {
    bg,
    haze: mixColors(bg, panel, 0.64),
    wisp: mixColors(bg, text, 0.36),
    accent: mixColors(cyan, violet, 0.35),
    logoPastelA: mixColors(textPrimary, violet, 0.46),
    logoPastelB: mixColors(textPrimary, cyan, 0.36),
    logoPastelC: mixColors(textPrimary, amber, 0.24),
    mark: textPrimary,
  };
}
